import { combineReducers } from 'redux';

import participants from './reducers/participants';
import login from './reducers/login';
import exams from './reducers/exams';

export default combineReducers({
  participants,
  login,
  exams
});


// WEBPACK FOOTER //
// ./src/rootReducer.js